/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import { Link } from "react-router-dom";
import useDashboardTotal from "../../hooks/useDashboardTotal";
import useInactiveVolunteerList from "../../hooks/useInactiveVolunteerList";
import useProfile from "../../hooks/useProfile";
import CurrentStudiesDashboard from "./CurrentStudiesDashboard";
import DashboardApproved from "./DashboardApproved";
import DashboardInactiveVolunteers from "./DashboardInactiveVolunteers";
import DashboardPending from "./DashboardPending";
import DashboardStorage from "./DashboardStorage";
import TodayTotal from "./TodayContainer/TodayTotal";
import TotalUser from "./TotalUser";
import TotalVolunteer from "./TotalVolunteer";
import useGetAllStudies from "../../hooks/useGetAllStudies";
import useGetFreshVolunteerList from "../../hooks/useGetFreshVolunteerList";

const Dashboard = () => {
  const [userData] = useProfile();
  const [dashboardTotalInfo, isLoading] = useDashboardTotal();
  const { getFreshVolunteerList } = useGetFreshVolunteerList();
  const [getAllStudiesList] = useGetAllStudies();

  const inActiveVolunteerNum = getFreshVolunteerList.length;

  const currentTrials = getAllStudiesList.length;

  // console.log("user data", userData);
  // console.log("dashboardtotal info", dashboardTotalInfo);
  return (
    <Box sx={{ flexGrow: 1, backgroundColor: "#F6F9FC", mt: 1 }}>
      <Grid columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid container spacing={2}>
          {/*//! Today volunteer */}
          {userData?.ugleve_name === "Admin" ||
          userData?.ugleve_name === "Developer" ? (
            <Grid
              item
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
              order={{ xs: 2, md: 1 }}
            >
              <Link
                to="/today-volunteer"
                style={{ textDecoration: "none", width: "100%" }}
              >
                <TodayTotal
                  userData={userData}
                  dashboardTotalInfo={dashboardTotalInfo}
                  isLoading={isLoading}
                />
              </Link>
            </Grid>
          ) : (
            <Grid
              item
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
              order={{ xs: 2, md: 1 }}
            >
              <TodayTotal
                userData={userData}
                dashboardTotalInfo={dashboardTotalInfo}
                isLoading={isLoading}
              />
            </Grid>
          )}

          {/*//! Pie chart */}
          {/* {(userData?.ugleve_name === "Admin" ||
            userData?.ugleve_name === "Developer") && (
            <Grid
              sx={{
                width: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
              item
              xs={12}
              sm={6}
              md={4}
              order={{ xs: 1, md: 2 }}
            >
              <DashboardPieChart />
            </Grid>
          )} */}
        </Grid>

        {/*  */}
        <Grid sx={{ mt: 2 }} item xs={12} md={6}>
          <Box sx={{ flexGrow: 1, pb: 4 }}>
            <Grid container spacing={2}>
              {/* total volunteer */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/total-volunteer">
                    <TotalVolunteer dashboardTotalInfo={dashboardTotalInfo} />
                  </Link>
                ) : (
                  <TotalVolunteer dashboardTotalInfo={dashboardTotalInfo} />
                )}
              </Grid>

              {/* total user */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/user-report">
                    <TotalUser
                      userData={userData}
                      dashboardTotalInfo={dashboardTotalInfo}
                      isLoading={isLoading}
                    />
                  </Link>
                ) : (
                  <TotalUser
                    userData={userData}
                    dashboardTotalInfo={dashboardTotalInfo}
                    isLoading={isLoading}
                  />
                )}
              </Grid>

              {/* approve volunteer */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/approve-volunteer">
                    <DashboardApproved
                      dashboardTotalInfo={dashboardTotalInfo}
                    />
                  </Link>
                ) : (
                  <DashboardApproved dashboardTotalInfo={dashboardTotalInfo} />
                )}
              </Grid>

              {/* pending volunteer */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/pending-volunteer">
                    <DashboardPending
                      isLoading={isLoading}
                      dashboardTotalInfo={dashboardTotalInfo}
                    />
                  </Link>
                ) : (
                  <DashboardPending
                    isLoading={isLoading}
                    dashboardTotalInfo={dashboardTotalInfo}
                  />
                )}
              </Grid>

              {/* storage */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/volunteer-storage">
                    <DashboardStorage
                      isLoading={isLoading}
                      dashboardTotalInfo={dashboardTotalInfo}
                    />
                  </Link>
                ) : (
                  <DashboardStorage
                    isLoading={isLoading}
                    dashboardTotalInfo={dashboardTotalInfo}
                  />
                )}
              </Grid>

              {/* inactive volunteers */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/inactive-volunteer">
                    <DashboardInactiveVolunteers
                      isLoading={isLoading}
                      dashboardTotalInfo={inActiveVolunteerNum}
                    />
                  </Link>
                ) : (
                  <DashboardInactiveVolunteers
                    isLoading={isLoading}
                    dashboardTotalInfo={inActiveVolunteerNum}
                  />
                )}
              </Grid>

              {/* current studies volunteers */}
              <Grid sx={{}} item sm={6} xs={12} md={6}>
                {userData?.ugleve_name === "Admin" ||
                userData?.ugleve_name === "Developer" ? (
                  <Link to="/current-studies">
                    <CurrentStudiesDashboard
                      data={getAllStudiesList}
                      isLoading={isLoading}
                    />
                  </Link>
                ) : (
                  <CurrentStudiesDashboard
                    isLoading={isLoading}
                    dashboardTotalInfo={0}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
